export * from './full-layout.component';



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/containers/full-layout/index.ts